import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { toast } from "react-toastify";
import api from "../../api/axios";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

export const AppliedOportunitiesModal = ({ open, handleClose, userId }) => {
  const navigate = useNavigate();

  const [applications, setApplications] = useState([]);

  const getApplications = async () => {
    const { data } = await api.get(
      "/application/get-by-professional/" + userId,
    );

    const ordered = data.sort((a, b) => {
      if (a.oportunity.status === "ativa" && b.oportunity.status !== "ativa")
        return -1;
      if (a.oportunity.status !== "ativa" && b.oportunity.status === "ativa")
        return 1;
      return 0;
    });

    setApplications(ordered);
    try {
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro");
    }
  };

  const handleCancelApplication = async (applicationId) => {
    try {
      await api.put(`/application/cancel-application/${userId}`, {
        applicationId,
      });

      toast.success("Candidatura cancelada com sucesso!");
      getApplications();
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro ao cancelar a candidatura");
    }
  };

  useEffect(() => {
    if (userId) {
      getApplications();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, open]);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "900px",
          minWidth: "300px",
        },
      }}
    >
      <DialogTitle textAlign="center">Candidaturas</DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            width: "100%",
            minWidth: "300px",
            gap: "1.5rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {Array.isArray(applications) && applications.length > 0 ? (
            applications.map((item) => (
              <div
                style={{
                  backgroundColor: "#f2f2f2",
                  width: "250px",
                  borderRadius: "5px",
                  padding: "20px",
                  border:
                    item.oportunity.status === "ativa"
                      ? "1px solid #104467"
                      : "none",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "15px",
                  }}
                >
                  <h2 style={{ color: "#104467", fontSize: "1rem" }}>
                    {item.oportunity.cargo}
                  </h2>
                </div>
                <div style={{ margin: "5px 0" }}>
                  <span style={{ fontSize: "0.8rem" }}>
                    {`Data da candidatura: ${dayjs(item.date).format(
                      "DD/MM/YYYY",
                    )}`}
                  </span>
                </div>
                <div
                  style={{
                    width: "100%",
                    maxHeight: "75px",
                    textAlign: "justify",
                    fontSize: "0.9rem",
                    overflowY: "auto",
                    textOverflow: "ellipsis",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  <span>{`Oportunidade na empresa ${item.oportunity.empresa}`}</span>
                </div>
                <div
                  onClick={() =>
                    navigate("/oportunidade/" + item.oportunity._id)
                  }
                  style={{
                    marginTop: "20px",
                    backgroundColor: "#104467",
                    height: "35px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "0.8rem",
                    color: "white",
                    cursor: "pointer",
                    borderRadius: "5px",
                  }}
                >
                  Ver Detalhes
                </div>
                {!item.canceled ? (
                  <div
                    onClick={() => handleCancelApplication(item._id)}
                    style={{
                      marginTop: "10px",
                      backgroundColor: "white",
                      height: "35px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "0.8rem",
                      color: "#104467",
                      cursor: "pointer",
                      borderRadius: "5px",
                      border: "1px solid #104467",
                    }}
                  >
                    Cancelar candidatura
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ))
          ) : (
            <span>
              Esse usuário não está cadastrado em nenhuma oportunidade
            </span>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button sx={{ color: "#104467" }} onClick={handleClose}>
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
